import { render, staticRenderFns } from "./user-show-details.vue?vue&type=template&id=3493b221&scoped=true"
import script from "./user-show-details.vue?vue&type=script&lang=js"
export * from "./user-show-details.vue?vue&type=script&lang=js"
import style0 from "./user-show-details.vue?vue&type=style&index=0&id=3493b221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493b221",
  null
  
)

export default component.exports